import { render } from "./LoginEcommerce.vue?vue&type=template&id=c489feec&scoped=true"
import script from "./LoginEcommerce.vue?vue&type=script&lang=js"
export * from "./LoginEcommerce.vue?vue&type=script&lang=js"

import "./LoginEcommerce.vue?vue&type=style&index=0&id=c489feec&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c489feec"]])

export default __exports__